import { flightApiConfigStoreKey } from "../../../reducers/types";
import { IStoreState } from "../../../reducers/types";
import { delay, put, select } from "redux-saga/effects";
import Logger from "../../../helpers/Logger";
import { actions } from "../actions";
import { fetchLocationAutocomplete } from "@hopper-b2b/api";
import { LocationQuery, LocationQueryEnum } from "@b2bportal/air-shopping-api";

export function* fetchDestinationCategories(
  action: actions.IFetchDestinationCategories
) {
  yield delay(300);
  try {
    const state: IStoreState = yield select();
    const { flightSearch } = state;
    const apiConfig = state[flightApiConfigStoreKey];
    const requestBody: LocationQuery = {
      LocationQuery: LocationQueryEnum.Label,
      l: action.queryString,
      searchParameters: {
        activeControl: "destination",
        origin: flightSearch?.origin?.id?.code?.code ?? null,
        tripType: flightSearch.tripCategory,
      },
    };
    const { categories } = yield fetchLocationAutocomplete(
      requestBody,
      apiConfig
    );

    yield put(actions.setDestinationCategories(categories));
  } catch (e) {
    Logger.debug(e);
    yield put(actions.setDestinationCategories([]));
  }
}
